import React from 'react'
import { Input } from '@progress/kendo-react-inputs';
import services from "../../../services";
import $ from "jquery";
import Inserirvasilha from './Inserirvasilha';

var thisState; // Variável de suporte para a função estática aceder à instância

class TipoOptionForm extends React.Component{

    state = {
        data : {},
        row:{},
        medida1:'',
        medida2:'',
        medida3:'',
        medida4:'',
        medida5:'',
        mediArr: [],
        editVasilhaDimension: []
    }

    componentDidMount(){
        thisState = this;

        (async () => {    
            if(parseInt($("#tipoVasilhas :selected").val()) != 0 && $("#tipoVasilhas :selected").val() != ""){
                
                var dataVasilha = {"idTipoVasilha" :parseInt($("#tipoVasilhas :selected").val()), "idVasilha": (this.props.row.idVasilha != null) ? this.props.row.idVasilha : this.props.data.idVasilha }
               
                if(dataVasilha.idVasilha == undefined ){
                    dataVasilha.idVasilha = 0
                }
                
                var vasilha = await services.apiCall.requestApi(
                    "/InstalacaoVinica/GetDimensoesVasilha",
                    dataVasilha,
                    "get"
                ); 
               if(vasilha){
                 $('#capac').val("");
                
                let newMediArr = [vasilha.medida1, vasilha.medida2, vasilha.medida3, vasilha.medida4, vasilha.medida5];
                let newEditDim = [vasilha.dimensao1, vasilha.dimensao2, vasilha.dimensao3, vasilha.dimensao4, vasilha.dimensao5];
     
                this.setState({
                    row: this.props.row,
                    data: newMediArr,
                    mediArr: newMediArr,
                    editVasilhaDimension: newEditDim,
                    medida1: vasilha.medida1,
                    medida2: vasilha.medida2,
                    medida3: vasilha.medida3,
                    medida4: vasilha.medida4,
                    medida5: vasilha.medida5
                }, () => {
                    this.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()));
                });
               }
                
                $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
            } else if(this.props.data.idVasilha != undefined){
                var dataVasilha = { "idVasilha": this.props.data.idVasilha}
                var vasilha = await services.apiCall.requestApi(
                    "/InstalacaoVinica/GetDimensoesVasilha",
                    dataVasilha,
                    "get"
                ); 
                if(vasilha){
                    $('#capac').val("");
            
                    let newMediArr = [vasilha.medida1, vasilha.medida2, vasilha.medida3, vasilha.medida4, vasilha.medida5];
                    let newEditDim = [vasilha.dimensao1, vasilha.dimensao2, vasilha.dimensao3, vasilha.dimensao4, vasilha.dimensao5];
           
                    this.setState({
                        row: this.props.row,
                        data: newMediArr,
                        mediArr: newMediArr,
                        editVasilhaDimension: newEditDim,
                        medida1: vasilha.medida1,
                        medida2: vasilha.medida2,
                        medida3: vasilha.medida3,
                        medida4: vasilha.medida4,
                        medida5: vasilha.medida5
                    }, () => {
                        this.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()));
                        Inserirvasilha.getVasilhasCalculation(newEditDim);
                    });
                    
                    $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
                }
            }
        })();
    }

    componentDidUpdate(prevProps) {
        if(JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
            this.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()))
        }
        thisState = this;
    }

    vasilhaMeasurements = (TipoVasilha) => {
        let medidaArr = {}
        const { mediArr, editVasilhaDimension } = this.state;

        Object.keys(mediArr).map((medida) => {
            if(mediArr[medida] != "-"){
                editVasilhaDimension.map((dimensao) => {
                    if(dimensao != "-")
                        medidaArr[medida] = editVasilhaDimension[dimensao] || ""
                })
            }
        })
        this.setState({
            data: {...this.state.data, ...medidaArr}
        },()=>{
            this.props.calFormValue(this.state.data, TipoVasilha)
        })
    }

    handleChange = (e) => {
        var medida1 = $("#0").val() != undefined ? $("#0").val() : "-"
        var medida2 = $("#1").val() != undefined ? $("#1").val() : "-"
        var medida3 = $("#2").val() != undefined ? $("#2").val() : "-"
        var medida4 = $("#3").val() != undefined ? $("#3").val() : "-"
        var medida5 = $("#4").val() != undefined ? $("#4").val() : "-"
        
        let dataarray = [medida1, medida2, medida3, medida4, medida5];

        this.setState({
            data : dataarray,
            editVasilhaDimension: dataarray
        })
    }
    
    checkFormatOfInput = (e) => {
        let checkIfNum = false
        if (e.key !== undefined) {
            checkIfNum = e.key === "e" || e.key === "+" || e.key === "-" || e.key === "E";
         }
         else if (e.keyCode !== undefined) {
            checkIfNum = e.keyCode === 69 || e.keyCode === 187 || e.keyCode === 189;
         }
         return checkIfNum && e.preventDefault();
    }

    checkPaste = (e) => {
        const pasteData = e.clipboardData.getData('text');
        if (pasteData.includes('-') || parseFloat(pasteData) < 0) {
            e.preventDefault();
        }
    }

    static GetDimencoesCampos(){
        if(thisState){
            (async () => {    
                if(parseInt($("#tipoVasilhas :selected").val()) != 0 && $("#tipoVasilhas :selected").val() != ""){
                    
                    var dataVasilha = {"idTipoVasilha" :parseInt($("#tipoVasilhas :selected").val()), "idVasilha": (thisState.props.row.idVasilha != null) ? thisState.props.row.idVasilha : thisState.props.data.idVasilha }
                   
                    if(dataVasilha.idVasilha == undefined ){
                        dataVasilha.idVasilha = 0
                    }
                    
                    var vasilha = await services.apiCall.requestApi(
                        "/InstalacaoVinica/GetDimensoesVasilha",
                        dataVasilha,
                        "get"
                    ); 
                   if(vasilha){
                     $('#capac').val("");
                    
                    let newMediArr = [vasilha.medida1, vasilha.medida2, vasilha.medida3, vasilha.medida4, vasilha.medida5];
                    let newEditDim = [vasilha.dimensao1, vasilha.dimensao2, vasilha.dimensao3, vasilha.dimensao4, vasilha.dimensao5];
         
                    thisState.setState({
                        row: thisState.props.row,
                        data: newMediArr,
                        mediArr: newMediArr,
                        editVasilhaDimension: newEditDim,
                        medida1: vasilha.medida1,
                        medida2: vasilha.medida2,
                        medida3: vasilha.medida3,
                        medida4: vasilha.medida4,
                        medida5: vasilha.medida5
                    }, () => {
                        thisState.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()));
                    });
                   }
                    
                    $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
                } else if(thisState.props.data.idVasilha != undefined){
                    var dataVasilha = { "idVasilha": thisState.props.data.idVasilha}
                    var vasilha = await services.apiCall.requestApi(
                        "/InstalacaoVinica/GetDimensoesVasilha",
                        dataVasilha,
                        "get"
                    ); 
                        if(vasilha){
                            $('#capac').val("");
                    
                            let newMediArr = [vasilha.medida1, vasilha.medida2, vasilha.medida3, vasilha.medida4, vasilha.medida5];
                            let newEditDim = [vasilha.dimensao1, vasilha.dimensao2, vasilha.dimensao3, vasilha.dimensao4, vasilha.dimensao5];
                   
                            thisState.setState({
                                row: thisState.props.row,
                                data: newMediArr,
                                mediArr: newMediArr,
                                editVasilhaDimension: newEditDim,
                                medida1: vasilha.medida1,
                                medida2: vasilha.medida2,
                                medida3: vasilha.medida3,
                                medida4: vasilha.medida4,
                                medida5: vasilha.medida5
                            }, () => {
                                thisState.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()));
                                Inserirvasilha.getVasilhasCalculation(newEditDim);
                            });
                            
                            $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
                        }
                }
            })();
        }
    }

    render(){
        const { mediArr, editVasilhaDimension } = this.state;
        
        if(mediArr && mediArr.length > 0){
            return (
                Object.keys(mediArr).map((medida) => {
                    if(mediArr[medida] != "-"){
                       return (
                           <div className="col-md-6 remove-medidas-input" key={medida}>
                               <div className="input-box active-grey">
                                   <Input 
                                       id={medida} 
                                       style={{ width: "100%" }} 
                                       className="input-1" 
                                       type="number" 
                                       min={0} 
                                       value={parseFloat(editVasilhaDimension[medida]) || 0} 
                                       name={mediArr[medida]} 
                                       label={mediArr[medida]} 
                                       onKeyDown={(e) => this.checkFormatOfInput(e)} 
                                       onChange={(e) => this.handleChange(e)} 
                                       onPaste={(e) => this.checkPaste(e)} 
                                   /> 
                               </div>
                           </div>
                       )
                    }
                })
            )
        }

        return ("")
    }
}

export default TipoOptionForm;